import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Spinner from "../../../elements/Spinner";
import { Button } from "@mantine/core";
import TextField from "@mui/material/TextField";
import Slider from "@mui/material/Slider";
import { GetClientOrderparametersByGameByLocation, GetOrderParametersResponse } from "../../../../api/api.gen";
import { getCurrencyTranslated, getCurrencyTranslatedWithCredits } from "../../../../utils/util";
import useGlobalState from "@/state";

const GameSelection = () => {
  let { cat, gamename, location } = useParams();
  const [Unit, setUnit] = useState(1);
  const [Allow, setAllow] = useState(false);
  const [minUnits, setMinUnits] = useState(1);
  const [maxUnits, setMaxUnits] = useState(1);
  const [OrderPramsResponse, SetOrderPramsResponse] = useState<GetOrderParametersResponse>();
  const selectedCurrency = useGlobalState(state => state.selectedCurrency)
  const [loading, setLoading] = useState(false);

  const setServerUnit = (val: string) => {
    if (Number(val) >= minUnits && Number(val) <= maxUnits) {
      setUnit(Number(val));
      setAllow(true);
    } 
  };

  const onRender = (gamename: string, location: string) => {
    setLoading(true);
    GetClientOrderparametersByGameByLocation(gamename, location)
      .then((response) => {
        setMinUnits(response.GameMinUnits);
        setMaxUnits(response.AvaliableUnits);
        setUnit(response.GameMinUnits);
        SetOrderPramsResponse(response);
        if ((OrderPramsResponse ? false : true) && response.AvaliableUnits != 0)
          setAllow(true);
      })
      .then(() => setLoading(false));
  };
  useEffect(() => {
    onRender(gamename, location);
  }, []);

  const GetCube = (color: string, Modifier: number) => {
    return (
      <svg
        className={color}
        height={150 * Modifier}
        width={150 * Modifier}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 445.555 445.555"
      >
        <g>
          <polygon points="237.777,243.019 237.777,445.555 409.166,337.631 409.167,135.095 	" />
          <polygon points="222.777,0 50.463,108.506 222.777,217.012 395.092,108.506 	" />
          <polygon points="36.388,337.631 207.777,445.555 207.777,243.019 36.388,135.095 	" />
        </g>
      </svg>
    );
  };

  return (
    <>
      {loading && <Spinner />}
      <div className="flex flex-col items-center justify-center gap-5 mt-10">
        <div className="flex flex-col lg:flex-row mt-[70px] lg:mt-0 items-center justify-center font-sans gap-24">
          {OrderPramsResponse ? (
            <>
            <div className="flex items-center justify-center">
              {OrderPramsResponse.AvaliableUnits != 0 && GetCube(
                "fill-blue-500 absolute z-10 transition ease-in-out",
                0.5 + Unit / maxUnits / 2
              )}
              {GetCube("fill-gray-500 absolute z-5 transition ease-in-out", 1)}
            </div>
            <div className="text-center text-white w-fit-content rounded-md bg-trueGray-800 border-1 px-14 py-5">
              <p className="p-2 font-sans">Specifications</p>
              {OrderPramsResponse.AvaliableUnits != 0 ? (
                <>
                  {cat != "website" ?
                    <>
                      <p className="p-2">
                        {Unit * OrderPramsResponse?.LocationUnits.cpu}% CPU
                      </p>
                      <p className="p-2">
                        {Unit * OrderPramsResponse?.LocationUnits.ram}MB RAM
                      </p>
                      <p className="p-2">
                        {Unit * OrderPramsResponse?.LocationUnits.ssd}MB NVMe SSD
                      </p>
                    </>
                  :
                    <>
                      <p className="p-2">
                        UNLIMITED Monthly Bandwidth
                      </p>
                      <p className="p-2">
                        DirectAdmin Control Panel
                      </p>
                      <p className="p-2">
                        FREE SSL Certificates
                      </p>
                      <p className="p-2">
                        FREE <a href="https://mailchannels.com" className="underline text-blue-400">Mailchannels</a> Email Delivery
                      </p>
                      <p className="p-2">
                        {Unit * OrderPramsResponse?.LocationUnits.ssd}GB NVMe SSD
                      </p>
                    </>
                  }
                  <p className="p-2">
                    {getCurrencyTranslatedWithCredits(Unit * OrderPramsResponse?.LocationUnits.cost, selectedCurrency)}
                  </p>
                </>
              ) : (
                <>
                  <p className="p-2 text-red-600">Out of Stock,</p>
                  <p className="p-2 text-red-600">please reach out to us via discord</p>
                </>
              )}
            </div>
            </>
          ) : (
            <div className="text-2xl text-red-600">
              Error Try again later please report this to our discord
            </div>
          )}
        </div>
        {OrderPramsResponse && OrderPramsResponse.AvaliableUnits != 0 &&
          <div className="w-1/2 flex flex-col lg:flex-row items-center justify-center gap-6">
            <Slider
              min={minUnits}
              max={maxUnits}
              value={Unit}
              //@ts-ignore
              onChange={(e) => setServerUnit(e.target.value)}
            />
            <div className="flex items-center justify-center gap-3">
              <TextField
                type="number"
                focused
                value={Unit}
                placeholder="Enter Plan Units"
                onChange={(e) => setServerUnit(e.target.value)}
              />
              <h2 className="font-[500]">Units</h2>
            </div>
          </div>
        }
      </div>
      {OrderPramsResponse && OrderPramsResponse.AvaliableUnits != 0 &&
        <div className="text-center my-10 w-1/2 m-auto">
          <Link
            to={`/dashboard/createserver/${cat}/${gamename}/${location}/${Unit}`}
          >
            <Button
              type="submit"
              disabled={
                (OrderPramsResponse ? false : true) ||
                (OrderPramsResponse?.AvaliableUnits != 0 ? false : true) ||
                !Allow
              }
              className="text-center group relative h-12 w-full flex justify-center py-2 px-4 border border-transparent font-medium rounded-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {Allow ? "Next" : "Disabled"}
            </Button>
          </Link>
        </div>
      }
      <div className="text-2xl text-center font-sans">
        Contact us via a Discord Ticket in case the package your looking for is
        not above
      </div>
    </>
  );
};

export default GameSelection;
